<template>
    <header>
        <img src="@/assets/img/logo.png" id="logo" style="color: #FFF; font-size: 1.2em; font-weight: initial">
        <p class="nomeCliente">{{ config.clienteNome }}</p>
        
    </header>
    <main>
        <div>
            <main class="main">
                <div class="mainDiv" style="display: inline-block;">
                    <div class="card" style="border-style: none;">
                        <div class="titulo-card">
                            <p class="pLocalizacao">Fazer chamado para: </p>
                            <!--<p class="pLocalizacao">
                                {{ quarto?._descricao || "Quarto Inexistente" }} - 
                                {{ leito?._descricao || "Leito Inexistente" }} 
                            </p>-->
                            <p class="pLocalizacao">
                                {{ state.quarto?._descricao || "Quarto Inexistente" }}
                            </p>
                            <p class="pLocalizacao">
                                {{ state.leito?._descricao || "Leito Inexistente" }}
                            </p>
                            <!--<input type="color" />-->
                        </div>
                        <div class="card-body w-100">
                            <Botoes v-for="tpChamado in state.tiposChamados" :key="tpChamado.id" :tpChamado="tpChamado"
                                :chamadosAbertos="state.chamadosAbertos" :listarAbertos="listarAbertos" @tpListar="tpListar"
                                @tpSalvar="tpSalvar" />
                        </div>
                    </div>
                </div>
                <div class="complemento scroll" v-if="chamadosEstaoAbertos">
                    <!-- <p class="pAbertos">Chamados Abertos</p> -->
                    <div class="listaAbertosDiv">
                        <hr />
                        <ListaAbertos v-for="listAb in state.chamadosAbertos" :key="listAb.id" :listAb="listAb"
                            :tpChamadoListSub="state.tpChamListar" @cancelar="cancelar" @excluir="excluir" />
                    </div>
                </div>

            </main>
        </div>
    </main>
    <footer class="">
        <p class="address m-0">Versão {{ state.versao }}</p>
    </footer>
</template>

<script setup>
import Botoes from '@/components/Botoes';
import store from '@/store/store';
import api from '@/api/api';
import ListaAbertos from '@/components/ListaAbertos.vue';
import Leito from '@/model/Leito';
import Quarto from '@/model/Quarto';
import Chamado from '@/model/Chamado';
import Setor from '@/model/Setor';
import TipoChamado from '@/model/TipoChamado';
import _versao from '@/../package.json';
import { computed, onMounted, reactive } from 'vue';
import roteador from '@/roteador/indexRoteador';

const state = reactive({
    numero: '',
    data: [],
    tiposChamados: [],
    chamadosAbertos: [],
    tpChamListar: [],
    cont: 0,
    leito: {},
    quarto: {},
    versao: _versao.version
});

onMounted(async () => {
    state.tiposChamados = await api.tipoChamadoListar();
    // console.log(teste);
    listarAbertos(false);
    cronometro();
    listarPorId();
    // console.log(state.tiposChamados);
});

async function excluir(id) {
    state.chamadosAbertos = state.chamadosAbertos.filter(cA => cA.id != id);
    listarAbertos()
}

async function cancelar(id) {
    state.chamadosAbertos = state.chamadosAbertos.filter(cA => cA.id != id);
    listarAbertos()
}

async function excluirAux(id) {
    state.chamadosAbertos = state.chamadosAbertos.filter(cA => cA.id != id);
}

async function adicionarAux(r) {
    state.chamadosAbertos.push(
        new Chamado(
            r.id,
            r.data,
            r.hora,
            new Leito(r.leito.id, r.leito.codigoLeito, r.leito.descricao, r.leito.ativo,
                new Quarto(r.leito.quarto.id, r.leito.quarto.codigoQuarto, r.leito.quarto.descricao, r.leito.quarto.ativo,
                    new Setor(r.leito.quarto.setor.id, r.leito.quarto.setor.ativo, r.leito.quarto.setor.codigoSetor, r.leito.quarto.setor.descricao))),
            new TipoChamado(r.tipoChamado.id, r.tipoChamado.descricao, r.tipoChamado.ativo, r.tipoChamado.cor, r.tipoChamado.som, r.tipoChamado.fonte, r.tipoChamado.borda, r.tipoChamado.corIcone, r.tipoChamado.urgencia, r.tipoChamado.id_Principal),
            r.posicao,
            r.dtFinalizacao,
            r.hrFinalizacao,
            r.dtCancelamento,
            r.hrCancelamento,
            r.motivo,
            r.letraEquipamento,
            r.letraChamado,
            r.avaliacao
        )
    );
}

async function listarAbertos() {
    api.listarAbertos(roteador.currentRoute.value.params.id, state.chamadosAbertos)
        .then(resposta => {
            // console.log(resposta);
            let auxiliar = [];

            api.filtrarDados("AB", 0, null, null, roteador.currentRoute.value.params.id)
                .then(resp => {
                    state.chamadosAbertos = resp;
                })
                .catch(erro => console.log(erro));

            auxiliar = [];

            state.chamadosAbertos.forEach(a => {
                let encontrou = false;
                if (a != null) {
                    resposta.forEach(r => {
                        if (a.id === r.id) {
                            encontrou = true;
                        }
                    });

                    if (encontrou) {
                        auxiliar.push(a.id);
                    }
                }
            });

            auxiliar.forEach(id => {
                excluirAux(id);
            });

            auxiliar = [];

            resposta.forEach(r => {
                let encontrou = false;
                state.chamadosAbertos.forEach(a => {
                    if (a.id === r.id) {
                        encontrou = true;
                    }
                });

                if (!encontrou) {
                    adicionarAux(r);
                }
            });
        })
        .catch(erro => console.log(erro));
}

async function cronometro() {
    setInterval(() => {
        listarAbertos();
    }, 5000);
}

async function listarPorId() {
    let ativo = true;
    api.listarLeitoId(roteador.currentRoute.value.params.id, ativo)
        .then(resposta => {
            state.leito = new Leito(
                resposta.id,
                resposta.codigoLeito,
                resposta.descricao,
                resposta.ativo,
                null
            );
            state.quarto = new Quarto(
                resposta.quarto.id,
                resposta.quarto.codigoQuarto,
                resposta.quarto.descricao,
                null, null
            );
        })
        .catch();
}

async function tpListar(tpChamadoListarSub) {
    state.tpChamListar = tpChamadoListarSub;
}

async function tpSalvar(tpChamListSub, chamAberto) {
    console.log(tpChamListSub);
    console.log(chamAberto);
    console.log("----------");
}

async function alterarAvaliacao(pId, pAvaliacao) {
    // console.log(pId);
    state.chamadosAbertos.forEach((c) => {
        // console.log(c);
        if (c.id === pId) {
            c.avaliacao = pAvaliacao;
        }
    });
}

const config = computed(() => {
    return store.state.config;
});
const chamadosEstaoAbertos = computed(() => {
    // if (!state.chamadosAbertos) {
    //     return state.chamadosAbertos.length == 0;
    // } else {
    //     return state.chamadosAbertos.length > 0;
    // }
    return (!state.chamadosAbertos) ? state.chamadosAbertos.length == 0 : state.chamadosAbertos.length > 0;
});
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
}

ul {
    display: flex;
    justify-content: center;
    width: 20%;
}

p {
    font-weight: bold;
    width: 20rem;
}

.mainContainer {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    width: 200px;
}

.lista {
    display: list-item;
    list-style: none;
    margin-bottom: -100%;
}

/* .container {
    width: auto;
    height: auto;
    margin-left: 0;
    margin-right: 0;
} */

.mainDiv {
    margin-right: 0;
    /*width: 20rem;*/
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    /*margin: center;
    border-width: 2px;
    border-style: solid;*/
    border-radius: 20px;
}

.pNomeHospital {
    margin-left: 15%;
    text-align: start;
}

.complemento {
    display: flex;
    flex-direction: column;
    align-items: center;

}

.listaAbertosDiv {
    display: flex;
    align-items: flex-start;
    /*justify-content: flex-start;
    margin: auto;
    border-width: 2px;
    border-style: solid;
    */
    align-items: center;
    width: 100%;
    border-radius: 10%;
    flex-direction: column;

}

.address {
    /*width: 100%;
    font-style: italic;
    font-size: 0.8rem;
    margin: 1% 0;
    align-items: flex-end;*/

    font-weight: lighter;
    width: 100%;
    font-style: italic;
    /* font-weight: lighter; 
  font-size: 0.8rem;*/
    align-items: flex-end;
    text-align: center;
}

.pLocalizacao {
    text-transform: uppercase;
    font-weight: bold;
    margin-left: 10%;
    text-align: left;
    font-size: 1.2em;
    color: var(--corFonteTitulo)
}

.card {
    padding: 0;
}


@media only screen and (min-width: 900px) {
    .scroll {
        position: relative;
        height: 600px;
        overflow: auto;
    }

    .mainDiv {
        margin-right: 15px;
        margin-left: 15px;
    }

    .main {
        display: flex;
    }
}
</style>